import { FEATURES } from '/src/features/_global/constants';

export const AUDIENCES_PERMISSIONS = {
  [FEATURES.AUDIENCES]: ({ capabilities }) => ({
    navigate: capabilities?.audiences.permissions.nav,
    view: capabilities?.audiences.permissions.view,
    edit: capabilities?.audiences.permissions.edit,
  }),
};
